module.exports = __webpack_public_path__ + "static/media/hero-left.31a15be9.jpg";